import { render, staticRenderFns } from "./Settlement.vue?vue&type=template&id=700ea2c1"
import script from "./Settlement.vue?vue&type=script&lang=ts"
export * from "./Settlement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports